import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/**
 * CommonDatePicker - Premium rounded pill date picker.
 *
 * Props:
 *   label          {string}   Label shown above the date picker
 *   required       {boolean}  Appends a red asterisk to the label
 *   selected       {Date}     Currently selected date
 *   onChange       {function} Called with the new Date when user picks a date
 *   placeholderText{string}   Placeholder (default: "DD/MM/YYYY")
 *   dateFormat     {string}   Format string for react-datepicker (default: "dd/MM/yyyy")
 *   showMonthDropdown  {boolean}
 *   showYearDropdown   {boolean}
 *   style          {object}   Extra style overrides for the input
 *   className      {string}   Extra classes for the input
 *   labelClass     {string}   Extra classes for the label
 *   wrapClass      {string}   Extra classes for the wrapping div
 */
const CommonDatePicker = ({
  label,
  required = false,
  selected,
  onChange,
  placeholderText = "DD/MM/YYYY",
  dateFormat = "dd/MM/yyyy",
  showMonthDropdown = false,
  showYearDropdown = false,
  style = {},
  className = "",
  labelClass = "",
  wrapClass = "",
}) => {
  return (
    <div className={wrapClass}>
      {label && (
        <label className={`text-black fw-bold mb-1 ${labelClass}`}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <div className="position-relative">
        <i
          className="far fa-calendar-days position-absolute"
          style={{
            left: "14px",
            top: "48%",
            transform: "translateY(-50%)",
            color: "#adb5bd",
            zIndex: 1,
          }}
        />
        <DatePicker
          selected={selected}
          onChange={onChange}
          placeholderText={placeholderText}
          dateFormat={dateFormat}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode="select"
          customInput={
            <input
              className={`form-control ${className}`}
              style={{ paddingLeft: "40px", ...style }}
            />
          }
          wrapperClassName="w-100"
        />
      </div>
    </div>
  );
};

export default CommonDatePicker;
